import { Box, Center } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const HeartRhythmNoteFields = () => {
  const { t } = useTranslation();

  return (
    <Box p={'xl'} my={'md'} bg={'var(--mantine-primary-color-light)'}>
      <Center>{t('trigger_no_config_text')}</Center>
    </Box>
  );
};
